export const DEFAULT = 'DEFAULT';
export const TEST = 'test';
export const DEV = 'development';
export const PROD = 'production';
export const NOW_UI_FRAMEWORK = 'nowUiFramework';
export const NOW_UI_CONFIG = 'NOW_UI_CONFIG';
export const NOW_UI_EVENT = 'NOW_UI_EVENT';

/**
 * Config Values
 */
export const AMB_GC = 'ambGC';
export const GQL_CACHE_CAPACITY = 'graphQLCacheCapacity';
export const GQL_CACHING_ENABLED = 'graphQLCachingEnabled';
export const GQL_CACHING_REFRESH_DELAY = 'graphQLCacheDelay';
export const GQL_CACHE_MAX_PERSIST = 'gqlCacheMaxPersist';
export const HTTP_CACHE_CAPACITY = 'httpCacheCapacity';
export const HTTP_CACHING_ENABLED = 'httpCachingEnabled';
export const HTTP_CACHING_REFRESH_DELAY = 'httpCacheDelay';
export const HTTP_CACHE_MAX_PERSIST = 'httpCacheMaxPersist';
export const TELEMETRY_MARKING_ENABLED = 'telemetryMarkingEnabled';
export const CHECK_FOR_POSSIBLE_PRESENTATIONAL_COMPONENTS =
	'checkForPossiblePresentationalComponents';
export const DISABLE_GQL_BATCHING = 'disableGraphQLBatching';
export const DISABLE_REST_BATCHING = 'disableRestBatching';
export const ENABLE_ACTION_DISPATCHED_HANDLING = 'enableActionDispatchedHandling';
export const GARBAGE_COLLECTOR_INTERVAL = 'GARBAGE_COLLECTOR_INTERVAL';
export const INTERSECT_ROOT_MARGIN = 'intersectRootMargin';
export const LOGGING_ENABLED = 'loggingEnabled';
export const LOGGING_LEVELS = 'loggingLevels';
export const LOGS_OBSERVER_INTERVAL = 'logsObserverInterval';
export const LOGS_CLEANUP_INTERVAL = 'logsCleanupInterval';
export const MEMOIZE = 'memoize';
export const METRICS_LEVEL = 'metricsLevel';
export const METRICS_OBSERVER_INTERVAL = 'metricsObserverInterval';
export const METRICS_TYPES = 'metricTypes';
export const POSSIBLE_PRESENTATIONAL_COMPONENTS = 'possiblePresentationalComponents';
export const QUEUE_FLUSH_ENABLED = 'queueFlushEnabled';
export const TIME_TO_WAIT_AFTER_DISCONNECT = 'TIME_TO_WAIT_AFTER_DISCONNECT';
export const VALIDATE_SCHEMAS = 'validateSchemas';
export const ENABLE_SCHEDULER_STATS = 'enableSchedulerStats';
export const METRICS_USE_WINDOW_PERFORMANCE = 'metricsUseWindowPerformance';
export const ENABLE_PROPERTY_DEEP_COMPARE = 'enablePropertyDeepCompare';
export const ENABLE_DECLARATIVE_STATE_UPDATE_DEEP_COMPARE =
	'enableDeclarativeStateUpdateDeepCompare';
export const PAGE_OPT_OUT_PROPERTY_DEEP_COMPARE = 'pageOptOutOfPropertyDeepCompare';
export const PAGE_OPT_OUT_STATE_DEEP_COMPARE = 'pageOptOutOfStateDeepCompare';
export const MEMOIZE_SNABBDOM_PROP_PARTS = 'memoizeSnabbdomPropParts';
export const ENABLE_SCHEDULER_QUEUE_COUNTS = 'enableSchedulerQueueCounts';
export const METRICS_ELEMENT_CONFIG_ENABLED = 'metricsElementConfigEnabled';
export const METRICS_COMPONENT_INTERACTIVE_ENABLED = 'metricsComponentInteractiveEnabled';
export const ARIA_LIVE_ASSERTIVE_TIMEOUT = 'ariaLiveAssertiveTimeout';
export const ARIA_LIVE_POLITE_TIMEOUT = 'ariaLivePoliteTimeout';
export const WHEN_COMPONENT_IS_IDLE_TIMEOUT = 'whenComponentIsIdleTimeout';
export const WHEN_COMPONENT_IS_IDLE_THROTTLE = 'whenComponentIsIdleThrottle';
export const WHEN_COMPONENT_IS_IDLE_MIN_INTERVAL = 'whenComponentIsIdleMinInterval';
export const SCHEDULER_RAF_TIMEOUT = 'schedulerRafTimeout';
export const METRICS_MARK_PRUNING_INTERVAL = 'metricsMarkPruningInterval';
export const METRICS_MARK_EXPIRATION = 'metricsMarkExpiration';
export const METRICS_PRUNE_MARKS = 'metricsPruneMarks';

export const EMBEDDABLE_BASE_URL = Symbol('EMBEDDABLE_BASE_URL');

export const NOW_UI_FRAMEWORK_CONFIG_KEYS = [
	AMB_GC,
	GQL_CACHE_CAPACITY,
	GQL_CACHING_ENABLED,
	GQL_CACHE_MAX_PERSIST,
	GQL_CACHING_REFRESH_DELAY,
	HTTP_CACHE_CAPACITY,
	HTTP_CACHING_ENABLED,
	TELEMETRY_MARKING_ENABLED,
	CHECK_FOR_POSSIBLE_PRESENTATIONAL_COMPONENTS,
	DISABLE_GQL_BATCHING,
	DISABLE_REST_BATCHING,
	ENABLE_ACTION_DISPATCHED_HANDLING,
	INTERSECT_ROOT_MARGIN,
	LOGGING_ENABLED,
	LOGGING_LEVELS,
	LOGS_OBSERVER_INTERVAL,
	LOGS_CLEANUP_INTERVAL,
	METRICS_LEVEL,
	METRICS_OBSERVER_INTERVAL,
	METRICS_TYPES,
	POSSIBLE_PRESENTATIONAL_COMPONENTS,
	QUEUE_FLUSH_ENABLED,
	VALIDATE_SCHEMAS,
	ENABLE_SCHEDULER_STATS,
	METRICS_USE_WINDOW_PERFORMANCE,
	PAGE_OPT_OUT_PROPERTY_DEEP_COMPARE,
	PAGE_OPT_OUT_STATE_DEEP_COMPARE,
	MEMOIZE_SNABBDOM_PROP_PARTS,
	ENABLE_SCHEDULER_QUEUE_COUNTS,
	ENABLE_PROPERTY_DEEP_COMPARE,
	ENABLE_DECLARATIVE_STATE_UPDATE_DEEP_COMPARE,
	METRICS_ELEMENT_CONFIG_ENABLED,
	METRICS_COMPONENT_INTERACTIVE_ENABLED,
	ARIA_LIVE_ASSERTIVE_TIMEOUT,
	ARIA_LIVE_POLITE_TIMEOUT,
	WHEN_COMPONENT_IS_IDLE_TIMEOUT,
	WHEN_COMPONENT_IS_IDLE_THROTTLE,
	WHEN_COMPONENT_IS_IDLE_MIN_INTERVAL,
	SCHEDULER_RAF_TIMEOUT,
	METRICS_MARK_PRUNING_INTERVAL,
	METRICS_MARK_EXPIRATION,
	METRICS_PRUNE_MARKS,
	EMBEDDABLE_BASE_URL
];

export const NXUI_SYS_PROPS = {
	'sn_nxui_framework.performance.cache.graphql.capacity': GQL_CACHE_CAPACITY,
	'sn_nxui_framework.performance.cache.graphql.enabled': GQL_CACHING_ENABLED,
	'sn_nxui_framework.performance.cache.graphql.max_persist': GQL_CACHE_MAX_PERSIST,
	'sn_nxui_framework.performance.cache.graphql.delay': GQL_CACHING_REFRESH_DELAY,
	'sn_nxui_framework.performance.cache.http.capacity': HTTP_CACHE_CAPACITY,
	'sn_nxui_framework.performance.cache.http.enabled': HTTP_CACHING_ENABLED,
	'sn_nxui_framework.performance.cache.http.max_persist': HTTP_CACHE_MAX_PERSIST,
	'sn_nxui_framework.performance.cache.http.delay': HTTP_CACHING_REFRESH_DELAY,
	'sn_nxui_framework.performance.telemetry.marking.enabled': TELEMETRY_MARKING_ENABLED,
	'sn_nxui_framework.performance.telemetry.window.top.enabled': METRICS_USE_WINDOW_PERFORMANCE,
	'sn_nxui_framework.performance.property.deep.compare.enabled': ENABLE_PROPERTY_DEEP_COMPARE,
	'sn_nxui_framework.performance.declarative.state.update.deep.compare.enabled':
		ENABLE_DECLARATIVE_STATE_UPDATE_DEEP_COMPARE,
	'sn_nxui_framework.performance.page.opt.out.property.deep.compare':
		PAGE_OPT_OUT_PROPERTY_DEEP_COMPARE,
	'sn_nxui_framework.performance.page.opt.out.state.deep.compare': PAGE_OPT_OUT_STATE_DEEP_COMPARE,
	'sn_nxui_framework.performance.memoize.snabbdom.prop.parts': MEMOIZE_SNABBDOM_PROP_PARTS,
	'sn_nxui_framework.performance.scheduler.queue.counts.enabled': ENABLE_SCHEDULER_QUEUE_COUNTS,
	'sn_nxui_framework.performance.scheduler.stats.enabled': ENABLE_SCHEDULER_STATS,
	'sn_nxui_framework.performance.metrics.element.config.enabled': METRICS_ELEMENT_CONFIG_ENABLED,
	'sn_nxui_framework.interactive_mark': METRICS_COMPONENT_INTERACTIVE_ENABLED,
	'sn_nxui_framework.disableGraphQLBatching': DISABLE_GQL_BATCHING,
	'sn_nxui_framework.whenComponentIsIdleTimeout': WHEN_COMPONENT_IS_IDLE_TIMEOUT,
	'sn_nxui_framework.whenComponentIsIdleThrottle': WHEN_COMPONENT_IS_IDLE_THROTTLE,
	'sn_nxui_framework.whenComponentIsIdleMinInterval': WHEN_COMPONENT_IS_IDLE_MIN_INTERVAL,
	'sn_nxui_framework.metricsObserverInterval': METRICS_OBSERVER_INTERVAL,
	'sn_nxui_framework.schedulerRafTimeout': SCHEDULER_RAF_TIMEOUT,
	'sn_nxui_framework.metricsMarkPruningInterval': METRICS_MARK_PRUNING_INTERVAL,
	'sn_nxui_framework.metricsMarkExpiration': METRICS_MARK_EXPIRATION,
	'sn_nxui_framework.metricsPruneMarks': METRICS_PRUNE_MARKS,
	'sn_nxui_framework.metricsLevel': METRICS_LEVEL,
	'sn_nxui_framework.logging.enabled': LOGGING_ENABLED,
	'sn_nxui_framework.logging.level': LOGGING_LEVELS
};
